import React from "react";

const Button = ({ children, center, href, link = false, ...props }) => {
  return link ? (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={href}
      target="_blank"
      {...props}
      className={`${
        center && "mx-auto"
      } text-white max-w-max py-3 px-6 text-sm font-bold gradient-primary grid grid-flow-col justify-start items-center gap-2`}
    >
      {" "}
      {children}
    </a>
  ) : (
    <button
      {...props}
      className={`${
        center && "mx-auto"
      } text-white  py-3 px-6 text-sm font-bold gradient-primary grid grid-flow-col justify-start items-center gap-2`}
    >
      {children}
    </button>
  );
};

export default Button;
